import { Component, Input, SimpleChanges } from '@angular/core';
import { AttachmentService } from '../../../attachments/attachment.service';
import UploadedAttachmentMetaData from '../../../attachments/models/UploadedAttachmentMetaData';
import { AttachmentEntityType } from '../../../attachments/enum/AttachmentEntityType';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-container-job-attachment-details',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './container-job-attachment-details.component.html',
  styleUrl: './container-job-attachment-details.component.scss'
})
export class ContainerJobAttachmentDetailsComponent {
  @Input()
  containerJobItemId: number | null = null;

  @Input()
  containerJobId?: number | null = null;

  attachments: UploadedAttachmentMetaData[] = [];

  isLoading: boolean = false;

  constructor(private attachmentService: AttachmentService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['containerJobItemId']) {
      this.containerJobItemId = changes['containerJobItemId'].currentValue
      this.loadContainerJobAttachments();
    }
  }

  ngOnInit(): void {
    this.loadContainerJobAttachments();
  }

  loadContainerJobAttachments(): void {
    this.isLoading = true;
    if (this.containerJobItemId && this.containerJobId) {
      this.attachmentService.getAttachmentsMetaDataListForEntity(this.containerJobId, AttachmentEntityType[AttachmentEntityType.Container], "")
        .subscribe((result) => {
          this.attachments = result;
          this.isLoading = false;
        });
    }
  }

  showAttachment(attachment: any) {
    window.open(`/api/attachments/${attachment.attachmentId}`, "_blank");
  }
}
